










































































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { mapState } from 'vuex';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import SimplePagination from '@/components/SimplePagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import { DateRange } from '@/components/DatePicker.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import {
  InstantPaymentResponse, InstantPaymentDetail, User,
} from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { AxiosError } from 'axios';

interface ReportParams {
  channel: { title: string; code: string; path: string; type: string };
  transactionDate: DateRange;
  paymentDate: DateRange;
  merchants: { merchant_code: string; merchant_name: string } | null;
  compcode: { credentials: string } | null;
  transactionStatuses: { label: string; value: string }[];
  transactionStatus: { label?: string; value?: string };
  transactionNumbers: SelectItem[];
  userIds: SelectItem[];
  customerNames: SelectItem[];
  amountTotals: SelectItem[];
  descriptions: SelectItem[];
  reasons: SelectItem[];
  generalSearch: string;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    SimplePagination,
    ActionPopup,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})
export default class ReportTable extends Vue {
  user!: {
    user: User;
  };

  channel = {
    title: '', code: '', path: '', type: '',
  };

  loading = true;
  transactions: InstantPaymentDetail[] = [];

  transactionStatus: { [key: string]: string } = {
    '00': 'Success',
    '01': 'Failed',
    '': 'Pending',
  }

  // pagination
  page = 1;
  tb: null | string = null;
  from = 0;
  to = 0;
  totalItem = 0;
  startTitle = '';
  endTitle = '';
  payStart = '';
  payEnd = '';
  hasNext = true;
  hasPrev = false;

  format!: (val: string) => string;

  params: ReportParams = {} as ReportParams;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openDetail(item: any) {
    // const tb = dayjs(date).format('YYYYMM');
    window.open(`/payment-gateway/transaction-report/${this.channel.type}/${this.channel.path}/${item.tb}/${item.id}`,
      '_blank');
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query },
    });
  }

  prev() {
    const lastId = this.hasPrev ? this.transactions[0].id : 0;
    const lastDate = this.hasPrev ? dayjs(this.transactions[0].transactionDate).format('YYYY-MM-DD HH:mm:ss') : '';

    this.getTransaction(this.params, false, lastId, lastDate, 'prev');
    this.page -= 1;
  }

  next() {
    const lastId = this.hasNext ? this.transactions[this.transactions.length - 1].id : 0;
    const lastDate = this.hasNext
      ? dayjs(this.transactions[this.transactions.length - 1].transactionDate).format('YYYY-MM-DD HH:mm:ss') : '';

    this.getTransaction(this.params, false, lastId, lastDate, 'next');
    this.page += 1;
  }

  async getTransaction(
    parameters: ReportParams, isExport = false, lastId?: number, lastDate?: string, action?: string,
  ) {
    this.params = parameters;

    this.channel = this.params.channel;

    try {
      if (!isExport) {
        this.loading = true;
      }

      const transactionDate = {
        startDate: this.params.transactionDate.startDate === null ? undefined
          : dayjs(this.params.transactionDate.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.params.transactionDate.endDate === null ? undefined
          : dayjs(this.params.transactionDate.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
        titleStart: this.params.transactionDate.startDate === null ? undefined
          : dayjs(this.params.transactionDate.startDate).format('DDMMYYYY'),
        titleEnd: this.params.transactionDate.endDate === null ? undefined
          : dayjs(this.params.transactionDate.endDate).format('DDMMYYYY'),
      };

      const paymentDate = {
        startDate: this.params.paymentDate.startDate === null ? undefined
          : dayjs(this.params.paymentDate.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.params.paymentDate.endDate === null ? undefined
          : dayjs(this.params.paymentDate.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
        payStart: this.params.paymentDate.startDate === null ? undefined
          : dayjs(this.params.paymentDate.startDate).format('DDMMYYYY'),
        payEnd: this.params.paymentDate.endDate === null ? undefined
          : dayjs(this.params.paymentDate.endDate).format('DDMMYYYY'),
      };

      const merchants = this.params.merchants ? this.params.merchants.merchant_code : undefined;
      const compcode = this.params.compcode ? this.params.compcode.credentials : undefined;
      const transactionStatus = this.params.transactionStatus?.value;
      const transactionNumbers = this.params.transactionNumbers.length === 0 ? undefined
        : this.params.transactionNumbers.map((e) => e.value);
      const userIds = this.params.userIds.length === 0 ? undefined
        : this.params.userIds.map((e) => e.value);
      const customerNames = this.params.customerNames.length === 0 ? undefined
        : this.params.customerNames.map((e) => e.value);
      const amountTotals = this.params.amountTotals.length === 0 ? undefined
        : this.params.amountTotals.map((e) => e.value);
      const descriptions = this.params.descriptions.length === 0 ? undefined
        : this.params.descriptions.map((e) => e.value);
      const reasons = this.params.reasons.length === 0 ? undefined
        : this.params.reasons.map((e) => e.value);

      const { data } = await api.get<InstantPaymentResponse>('/transaction', {
        params: {
          channel: this.channel.code,
          startDate: transactionDate.startDate,
          endDate: transactionDate.endDate,
          paymentStartDate: paymentDate.startDate,
          paymentEndDate: paymentDate.endDate,
          'merchantCode[]': merchants,
          status: transactionStatus === 'all' ? undefined : transactionStatus,
          general: this.params.generalSearch.length === 0 ? undefined : this.params.generalSearch,
          transactionNo: transactionNumbers,
          userId: userIds,
          credential: compcode,
          customerName: customerNames,
          amount: amountTotals,
          description: descriptions,
          reason: reasons,
          export: isExport ? true : undefined,
          actionPage: action,
          tb: this.tb || undefined,
          lastId,
          lastDate,
        },
      });

      this.$emit('total', data.total);

      if (isExport) {
        const downloadData = data as unknown as { download: string[] };
        return downloadData.download;
      }

      this.transactions = data.data;
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      this.tb = null;
      if (this.page > 1) {
        this.tb = data.tb;
      }

      this.hasPrev = data.prevUrl !== '' && this.page > 1;
      this.hasNext = data.nextUrl !== '';

      this.startTitle = transactionDate.titleStart as string;
      this.endTitle = transactionDate.titleEnd as string;
      this.payStart = paymentDate.payStart as string;
      this.payEnd = paymentDate.payEnd as string;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line max-len
  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

    try {
      const url = await this.getTransaction(params, true);
      console.log(url);
      if (Array.isArray(url)) this.downloadSheet(url);
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, `Error [${(err as AxiosError).response?.status}]`, 'Failed to export transaction');
    }

    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export finished');
  }

  // eslint-disable-next-line class-methods-use-this
  sleep(n: number) {
    // eslint-disable-next-line arrow-parens
    return new Promise(resolve => setTimeout(resolve, n));
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(urls: string[]) {
    // eslint-disable-next-line no-restricted-syntax
    for (const url of urls) {
      const fileLink = document.createElement('a');
      fileLink.href = url;

      document.body.appendChild(fileLink);
      fileLink.click();
      // eslint-disable-next-line no-await-in-loop
      await this.sleep(1000);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
